/* Special Art Books · ricerca predittiva per il <dialog> della ricerca dell'header (header di BASE).
   Uso (una riga nel layout o nell'header: <script src="{{ 'sab-c-predictive.js' | asset_url }}" defer></script>):
     <sab-predictive data-url="{{ routes.predictive_search_url }}">
       <form action="{{ routes.search_url }}" role="search"> … <input type="search" name="q" …> … </form>
       <p class="sab-search__try" data-predictive-hide>…</p>            (facoltativo: si nasconde quando ci sono risultati)
       <div class="sab-search__results" data-predictive-results aria-live="polite"></div>
     </sab-predictive>
   Chiede /search/suggest?q=…&section_id=sab-c-predictive (sections/sab-c-predictive.liquid) e mette l'HTML nel contenitore.
   Da 2 caratteri, 220 ms dopo l'ultimo tasto; la richiesta vecchia si annulla. Senza JS il modulo va a /search. */
(() => {
  'use strict';
  if (customElements.get('sab-predictive')) return;

  class SabPredictive extends HTMLElement {
    connectedCallback() {
      if (this.isWired) return;
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results) return;
      this.isWired = true;
      this.controller = null;
      this.cache = new Map();
      if (!this.results.id) this.results.id = `sab-predictive-${Math.random().toString(36).slice(2, 8)}`;
      this.input.setAttribute('aria-controls', this.results.id);
      this.input.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.search(), 220);
      });
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2 && !this.results.childElementCount) this.search();
      });
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    show(html) {
      this.results.innerHTML = html;
      const has = Boolean(html);
      this.results.hidden = !has;
      this.querySelectorAll('[data-predictive-hide]').forEach((el) => { el.hidden = has; });
    }

    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) {
        if (this.controller) this.controller.abort();
        this.show('');
        return;
      }
      if (this.cache.has(q)) {
        this.show(this.cache.get(q));
        return;
      }
      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      const base = this.dataset.url || '/search/suggest';
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product,collection,article,page',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        section_id: 'sab-c-predictive',
      });
      try {
        const response = await fetch(`${base}?${params}`, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const box = doc.querySelector('[data-predict]');
        const html = box ? box.outerHTML : '';
        this.cache.set(q, html);
        if (this.input.value.trim() === q) this.show(html);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        this.show('');
      }
    }
  }

  customElements.define('sab-predictive', SabPredictive);
})();
